import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function ResetPasswordPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // All password resets now use the code-based flow on /forgot-password
    navigate("/forgot-password", { replace: true });
  }, [navigate]);

  return null;
}
